<template>
  <div class="verify-code-container">
    <div class="wrapper-content-verify-code">
      <div class="wraper-title">
        <h1 class="header">Check your inbox!</h1>
        <h3 class="text-modal">
          <ResendCode
            v-bind="resendCodeBind"
            :action="sendCode"
            :action-data="{ email }"
            @resended="refreshCode"
          />
        </h3>
      </div>
      <!-- <div v-if="regPhone">
        <p class="mb-0">
          {{
            $$t(
              'Please, enter confirmation code here. We have sent SMS to your phone:',
              'footer-text-phone'
            )
          }}
        </p>
        <p class="text-light font-weight-bold font-size-pre-lg">
          +{{ regPhone }}
        </p>
      </div> -->

      <InputVerify
        v-model="code"
        class="number-wrapper"
        tag="form"
        auto-send
        :tabindex="2"
        :count="$options.verifyCodeCount"
        @onSubmit="formSubmit"
        @error="formError"
      />

      <div class="text-danger text-center">
        {{ errorText || errorRequest }}
      </div>
      <button class="send-code-btn" @click.prevent="formSubmit">Sign up</button>
    </div>
    <ModalBackdrop
      v-model="isLoading"
      class="verify-code-loader"
      :variant="'loader'"
    >
      <img
        src="~@/assets/images/playhera-indo/Playhera_Loader.svg"
        alt="Loader"
      />
    </ModalBackdrop>
  </div>
</template>

<script>
import { mapMutations, mapActions, mapGetters } from 'vuex';
import { prop } from '@/utils/factories';

import { translate } from '@/mixins/translate';

import InputVerify from '@/components/form/NewInputVerify';
import ResendCode from '@/components/text/ResendCode';

import ModalBackdrop from '@/components/common/ModalBackdrop.vue';

let routerNameTo;

export default {
  name: 'Verification',
  components: {
    InputVerify,
    ModalBackdrop,
    ResendCode,
  },
  inject: ['$validator'],
  mixins: [translate('_web_verify-code')],
  props: {
    tokenToSend: prop(String),
    email: prop(String),
    from: prop(String),
  },
  data() {
    return {
      code: '',
      isLoading: false,
      errorRequest: null,
      errorText: null,
      resendTimer: 0,
      intervalTimer: 0,
      sectionWidth: 0,
    };
  },
  computed: {
    ...mapGetters(['templateRegData']),
    regEmail() {
      return this.$lodash.get(this, 'templateRegData.email') || this.email;
    },
    resendCodeBind() {
      if (this.regEmail) {
        return {
          timeoutTextTranslateKey: 'timeout-text_email',
          timeoutTextDefault:
            'We got your request. Re-send button will be available in {timer} sec.',
          resendTextTranslateKey: 'retry-text_email',
          resendTextDefault:
            " We've sent you a temporary 4-digit sign up code at Enter the code to verify your account. Please enter this code to sign up. Didn`t receive the code? {:resend}",
        };
      } else return null;
    },
  },
  beforeRouteLeave({ name }, from, next) {
    routerNameTo = name;
    this.errors.clear();
    next();
  },
  created() {
    this.$options.verifyCodeCount = 4;
  },
  destroyed() {
    if (
      routerNameTo &&
      routerNameTo !== 'signup' &&
      routerNameTo !== 'passwordReset'
    ) {
      this.saveRegData(null);
    }
  },
  methods: {
    ...mapActions([
      'verifyUser',
      'createProfile',
      'sendCode',
      'errorNotify',
      'closeModal',
      'openModal',
    ]),
    ...mapMutations(['saveRegData']),
    formSubmit(code) {
      // this.sectionWidth = this.$el.closest('.view-content-wrapper').offsetWidth;
      this.isLoading = true;
      this.errorRequest = null;
      this.$validator
        .validateAll()
        .then(result =>
          result
            ? Promise.resolve({
                code: this.code, // or code: this.code
                from: 'verify-email',
              })
            : Promise.reject('Invalid Code')
        )
        .then(
          this.verifyUser({
            providedTemp: this.tokenToSend,
            code,
            email: this.regEmail,
            from: 'verify-code-modal',
          }).catch(err => {
            this.isLoading = false;
            this.errorText = err.message;
          })
        )
        .then(() => {
          if (this.from === 'signup') {
            setTimeout(() => {
              this.isLoading = false;

              this.openModal({
                name: 'AccountCreatedModal',
                settings: {
                  clickOnBackdrop: false,
                  escKey: false,
                  variant: 'transparent',
                },
              });
            }, 1500);
          } else {
            setTimeout(() => {
              this.isLoading = false;

              this.openModal({
                name: 'PasswordSubmitModal',
                settings: {
                  clickOnBackdrop: false,
                  escKey: false,
                  variant: 'transparent',
                },
              });
            }, 1500);
          }
        })
        .catch(err => {
          this.isLoading = false;
          this.code = '';
          this.errorRequest = err.message || err;
          const from = this.$route.params.from;
          if (
            err === this.$t('_web_session_expired_error', 'Session expired') &&
            from
          ) {
            this.errorNotify(err);
            this.$nextTick(() => this.$router.push({ name: from }));
          }
        });
    },
    formError(err) {
      this.code = '';
      this.errorText = err;
    },
    refreshCode() {
      this.code = '';
    },
  },
};
</script>
<style lang="scss" scoped>
.verify-code-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  font-family: 'Alexandria', sans-serif;
  border-radius: 1rem;
  background: #151520 !important;
  max-width: 625px;
  padding: 40px 2rem;
  min-width: 625px;
  min-height: 75dvh;
  max-height: 90dvh;

  @media (max-width: 900px) {
    max-width: 525px;
    min-width: 525px;
  }
  @media (max-width: 600px) {
    max-width: 455px;
    min-width: 455px;
    overflow-y: auto;
  }
  @media (max-width: 450px) {
    max-width: 325px;
    min-width: 325px;
    overflow-y: auto;
  }
  @media (max-height: 600px) {
    overflow-y: scroll;
    justify-content: flex-start;
  }
  > .wrapper-content-verify-code {
    display: flex;
    width: 100%;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 2rem;
    > .wraper-title {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 0.25rem;
      width: 100%;
      align-self: stretch;

      > .header {
        font-size: 2rem;
        font-style: normal;
        font-weight: 600;
        line-height: 135%; /* 43.2px */
        letter-spacing: -0.48px;
        background: var(
          --Title,
          linear-gradient(
            90deg,
            rgba(255, 255, 255, 0.5) 5.29%,
            rgba(255, 255, 255, 0.91) 51.55%,
            rgba(255, 255, 255, 0.5) 100%
          )
        );
        background-clip: content-box;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
      > .text-modal {
        font-size: 14px;
        font-style: normal;
        max-width: 465px;

        font-weight: 400;
        line-height: 20px;
        color: rgba(255, 255, 255, 0.5);
        text-align: center;
      }
    }
    > .number-wrapper {
      display: flex;
      width: 100%;
      align-items: flex-start;
      gap: 0.5rem;
      align-self: stretch;
      justify-content: center;
    }
    > .send-code-btn {
      display: flex;
      padding: 1rem;
      justify-content: center;
      align-items: center;
      gap: 0.75rem;
      align-self: stretch;
      border-radius: 1rem;
      background: #fff;
    }
  }
}

.verify-code-loader {
  width: 100vw !important;
  > .modalbackdrop_container {
    background: none !important;
    background-color: transparent !important;
  }
}
</style>
